import React from 'react';
import { WhyUs } from '../components/WhyUs';
export function Nosotros() {
  return <div className="pt-24" data-id="element-431">
      <WhyUs data-id="element-432" />
    </div>;
}